// redux
import { combineReducers } from "redux"
// app
import person, { fetching as personFetching, error as personError } from "./person/reducer.js"
import licenses, { fetching as licensesFetching, error as licensesError } from "./licenses/reducer.js"
import medicals, { fetching as medicalsFetching, error as medicalsError } from "./medicals/reducer.js"
import visas, { fetching as visasFetching, error as visasError } from "./visas/reducer.js"
import ratings, { fetching as ratingsFetching, error as ratingsError } from "./ratings/reducer.js"
import languages, { fetching as languagesFetching, error as languagesError } from "./languages/reducer.js"
import jobs, { fetching as jobsFetching, error as jobsError } from "./jobs/reducer.js"
import contacts, { fetching as contactsFetching, error as contactsError } from "./contacts/reducer.js"
import citizenships, {fetching as citizenshipsFetching, error as citizenshipsError } from "./citizenship/reducer.js"
import files, { fetching as filesFetching, error as filesError } from "./files/reducer.js"
import notes, { fetching as notesFetching, error as notesError } from "./notes/reducer.js"


export function fetching(state) {
    return personFetching(state.person) ||
        licensesFetching(state.licenses) ||
        medicalsFetching(state.medicals) ||
        visasFetching(state.visas) ||
        ratingsFetching(state.ratings) ||
        languagesFetching(state.languages) ||
        jobsFetching(state.jobs) ||
        citizenshipsFetching(state.citizenships) ||
        contactsFetching(state.contacts) ||
        filesFetching(state.files) ||
        notesFetching(state.notes)
}

export function error(state) {
    // person
    const p = personError(state.person)
    if (p !== false) return p
    // licenses
    const l = licensesError(state.licenses)
    if (l !== false) return l
    // medical
    const m = medicalsError(state.medicals)
    if (m !== false) return m
    // visas
    const v = visasError(state.visas)
    if (v !== false) return v
    // visas
    const r = ratingsError(state.ratings)
    if (r !== false) return r
    // languages
    const ll = languagesError(state.languages)
    if (ll !== false) return ll
    // jobs
    const j = jobsError(state.jobs)
    if (j !== false) return j
    // citizenships
    const cs = citizenshipsError(state.citizenships)
    if (cs !== false) return cs
    // contacts
    const c = contactsError(state.contacts)
    if (c !== false) return c
    // files
    const d = filesError(state.files)
    if (d !== false) return d
    // notes
    const n = notesError(state.notes)
    if (n !== false) return n

    return false
}

export default combineReducers({
    person,
    licenses,
    medicals,
    visas,
    ratings,
    languages,
    jobs,
    contacts,
    citizenships,
    files,
    notes
})


/** WEBPACK FOOTER **
 ** ./src/actions/profile/reducer.js
 **/